import gql from "graphql-tag";

/** Logged-in only — firstname/lastname are blocked for guests by GraphQL auth. */
export default gql`
  query getSellerDisplayName($sellerId: Int!) {
    userById(id: $sellerId) {
      id
      firstname
      lastname
    }
  }
`;
